import { SearchEntity } from 'v2/models';

export enum TypeOfColumn {
  title = 'title',
  titleDetailed = 'titleDetailed',
  originator = 'originator',
  originatorDetailed = 'originatorDetailed',
  reviewer = 'reviewer',
  searchType = 'searchType',
  responses = 'responses',
  conversations = 'conversations',
  dateCreated = 'dateCreated',
  reviewStatus = 'reviewStatus',
  lastActivity = 'lastActivity',
}

export interface ColumnOptions {
  type: TypeOfColumn;
  label: string;
  disabled?: boolean;
  responsesCount?: { [key: string]: number };
  conversationCount?: { [key: string]: number };
  sortable?: boolean;
  ascField?: string;
  descField?: string;
}

export type Columns = ColumnOptions[];

export interface ColumnComponentProps {
  search: SearchEntity;
  options: ColumnOptions;
}

export const searchViewPath = {
  active: '/requests/requester/active',
  inProgress: '/requests/requester/in-progress',
  inReview: '/requests/requester/in-review',
  archived: '/requests/requester/archived',
  allSearches: '/requests/reviewer/all-requests',
  forReview: '/requests/reviewer/for-review',
  searches: '/requests',
};
